<div class="wrapper">
    <a
        [routerLink]="['/', 'portal', 'dashboard']"
        class="fw:semibold c:grey-1"
    >
        <i ctrlIcon="chevron_left"></i> <span>Zurück zum Dashboard</span></a
    >
    <div>
        <app-page-header headline="Dein Kundenkonto" />
        <p>
            Die Bankverbindungen findest du ab sofort für jeden Vertrag einzeln auf der
            <a [routerLink]="['/', 'portal', 'vertrag-waehlen-fuer-bezahlmethoden']">neuen Vertragsseite</a>.
        </p>
        <div class="widget-list">
            <app-billing-address-collapsible />
            <app-login-credentials-collapsible />
            <app-deactivate-account />
        </div>
    </div>
</div>
